import { useNavigate } from "react-router";
import { useServices } from "@/app/use-services";
import { PATHS } from "../destinations";
import { Splash } from "../screens/Splash";

/** The open, wired: "Get started" begins intake; the link goes straight to sign-in. */
export function WelcomeRoute() {
  const navigate = useNavigate();
  const { analytics } = useServices();
  return (
    <Splash
      onStart={() => {
        analytics.track({ name: "get started tapped" });
        navigate(PATHS.date);
      }}
      onSignIn={() => {
        analytics.track({ name: "sign in tapped" });
        navigate(PATHS.signIn);
      }}
    />
  );
}
